import Cookies from "js-cookie";
import config from "../../../config";
var FavoritesBrowserStorageService = (function () {
    function FavoritesBrowserStorageService() {
    }
    FavoritesBrowserStorageService.getCustomerId = function () {
        var cid = Cookies.get(config.CUSTOMER_ID_COOKIE);
        return cid ? Number(cid) : undefined;
    };
    FavoritesBrowserStorageService.getFavorites = function () {
        var favorites = null;
        try {
            var json = window.localStorage.getItem(config.ONNIT_FAVORITES);
            favorites = json ? JSON.parse(json) : null;
        }
        catch (error) {
            console.debug("Storage: Failed to get customer favorites in localStorage.", error);
        }
        return favorites;
    };
    FavoritesBrowserStorageService.setFavorites = function (favorites) {
        try {
            window.localStorage.setItem(config.ONNIT_FAVORITES, JSON.stringify(favorites));
        }
        catch (error) {
            console.error("Storage: Failed to set favorites in localStorage.", error);
        }
    };
    FavoritesBrowserStorageService.removeFavorites = function () {
        try {
            window.localStorage.removeItem(config.ONNIT_FAVORITES);
            console.debug("Storage: Removed favorites from localStorage.");
        }
        catch (error) {
            console.debug("Storage: Failed to remove favorites from localStorage.", error);
        }
    };
    return FavoritesBrowserStorageService;
}());
export default FavoritesBrowserStorageService;
//# sourceMappingURL=FavoritesBrowserStorageService.js.map